module.exports = __webpack_public_path__ + "img/img74.2770c525.png";